// extracted by mini-css-extract-plugin
export default {"container":"OnboardingLayout_container__oT5+B"};